import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { EditorState, Modifier } from 'draft-js';
import { Typography, Button } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';

const Modal = styled.div`
  background-color: white;
  position: absolute;
  width: 200px;
  height: 100px;
  top: 2rem;
  left: 0;
  border: 1px solid #f1f1f1;
  padding: 1rem;
  z-index: 2;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledButton = styled(Button)`
  padding: 1px 12px;
  line-height: 24px;
  margin: 0 5px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
`;

const CtaLink = ({ onChange, editorState }: any) => {
  const t = useFormatMessage();
  const [urlText, setUrlText] = useState(
    t('templates.base.surveyButton', 'Start Survey')
  );
  const [modal, setModal] = useState(false);

  const addStar = () => {
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      `#CTA-START#${urlText}#CTA-END#`,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, 'insert-characters'));

    setModal(false);
  };

  return (
    <Wrapper>
      <StyledButton
        onClick={() => {
          setModal(true);
        }}
        variant="primary"
      >
        {t('templates.base.ctaButton', 'Survey Button')}
      </StyledButton>
      {modal && (
        <Modal>
          <label>
            <Typography>
              {t('templates.base.ctaButtonText', 'Cta button text')}
            </Typography>
          </label>
          <input
            type="text"
            value={urlText}
            placeholder={t('templates.base.ctaPlaceholder', 'Start Survey')}
            onChange={(e: any) => setUrlText(e.target.value)}
          />
          <ButtonWrapper>
            <StyledButton onClick={addStar}>
              {t('templates.base.save', 'Save')}
            </StyledButton>
            <StyledButton variant="outlined" onClick={() => setModal(false)}>
              {t('templates.base.cancel', 'Cancel')}
            </StyledButton>
          </ButtonWrapper>
        </Modal>
      )}
    </Wrapper>
  );
};

export default CtaLink;
